export default __webpack_public_path__ + "nav-side-btn-inactive.png?0c5e0f41023d7a61829064d84b074499";